/**
 * All CBO Permissions
 * Naming for the enums should be [ITEM]_[ACTION]
 */
export enum CboRole {
  // SERVICE SUPER USER
  // Should be used to control access to maintenance/e2e endpoints
  // It should not be assigned to users
  SERVICE_SUPERUSER = 'CBO_SERVICE_SUPERUSER',

  // Calendars
  FISCAL_CALENDAR_EDIT = 'CBO_FISCAL_CALENDAR_EDITOR',
  FISCAL_CALENDAR_VIEW = 'CBO_FISCAL_CALENDAR_VIEWER',
  FISCAL_CALENDAR_ADMIN = 'CBO_FISCAL_CALENDAR_ADMIN',
  PAYROLL_CALENDAR_EDIT = 'CBO_PAYROLL_CALENDAR_EDITOR',
  PAYROLL_CALENDAR_VIEW = 'CBO_PAYROLL_CALENDAR_VIEWER',
  PAYROLL_CALENDAR_ADMIN = 'CBO_PAYROLL_CALENDAR_ADMIN',

  // Labor
  EMPLOYEE_VIEW = 'CBO_EMPLOYEE_VIEWER',
  EMPLOYEE_EDIT = 'CBO_EMPLOYEE_EDITOR',
  EMPLOYEE_ADMIN = 'CBO_EMPLOYEE_ADMIN',

  // Labor - deprecated
  // TODO: Remove these permissions after we change references in FE & BE services
  EMPLOYEE_CREATE = 'CBO_EMPLOYEE_CREATOR',
  EMPLOYEE_PERSONAL_EDIT = 'CBO_EMPLOYEE_PERSONAL_EDITOR',
  EMPLOYEE_PERSONAL_CREATOR = 'CBO_EMPLOYEE_PERSONAL_CREATOR',
  EMPLOYEE_JOB_CODE_GROUP_CONFIG_WRITE = 'CBO_EMPLOYEE_JOB_CODE_GROUP_CONFIG_WRITER',
  EMPLOYEE_JOB_CODE_GROUP_CONFIG_VIEW = 'CBO_EMPLOYEE_JOB_CODE_GROUP_CONFIG_VIEWER',

  LABOR_CONFIG_VIEW = 'CBO_LABOR_CONFIG_VIEWER',
  LABOR_CONFIG_EDIT = 'CBO_LABOR_CONFIG_EDITOR',
  LABOR_CONFIG_CREATE = 'CBO_LABOR_CONFIG_CREATOR',
  LABOR_CONFIG_ADMIN = 'CBO_LABOR_CONFIG_ADMIN',

  // Labor Rules Engine
  LRE_RULE_READER = 'CBO_LRE_RULE_READER',
  LRE_RULE_WRITER = 'CBO_LRE_RULE_WRITER',
  LRE_RULE_EXEC = 'CBO_LRE_RULE_EXEC',

  EMPLOYEE_CONFIG_VIEW = 'CBO_EMPLOYEE_CONFIG_VIEWER',
  EMPLOYEE_CONFIG_EDIT = 'CBO_EMPLOYEE_CONFIG_EDITOR',
  EMPLOYEE_CONFIG_CREATE = 'CBO_EMPLOYEE_CONFIG_CREATOR',
  EMPLOYEE_CONFIG_ADMIN = 'CBO_EMPLOYEE_CONFIG_ADMIN',
  EMPLOYEE_CONFIG_ORG_VIEWER = 'CBO_EMPLOYEE_CONFIG_ORG_VIEWER',
  EMPLOYEE_CONFIG_PERSONAL_VIEWER = 'CBO_EMPLOYEE_CONFIG_PERSONAL_VIEWER',

  JOBCODE_CONFIG_VIEW = 'CBO_JOBCODE_CONFIG_VIEWER',
  JOBCODE_CONFIG_EDIT = 'CBO_JOBCODE_CONFIG_EDITOR',
  JOBCODE_CONFIG_CREATE = 'CBO_JOBCODE_CONFIG_CREATOR',
  JOBCODE_CONFIG_ADMIN = 'CBO_JOBCODE_CONFIG_ADMIN',

  PAYRATE_VIEW = 'CBO_PAYRATE_VIEWER',
  PAYRATE_EDIT = 'CBO_PAYRATE_EDITOR',
  PAYRATE_CREATE = 'CBO_PAYRATE_CREATOR',
  PAYRATE_ADMIN = 'CBO_PAYRATE_ADMIN',

  POS_MAPPING_READER = 'ASM_POS_MAPPING_READER',
  POS_MAPPING_WRITER = 'ASM_POS_MAPPING_WRITER',

  LABOR_GROUP_VIEW = 'CBO_LABOR_GROUP_VIEWER',
  LABOR_GROUP_EDIT = 'CBO_LABOR_GROUP_EDITOR',
  LABOR_GROUP_CREATE = 'CBO_LABOR_GROUP_CREATOR',
  LABOR_GROUP_ADMIN = 'CBO_LABOR_GROUP_ADMIN',

  TIP_SHARE_GROUP_VIEW = 'CBO_TIP_SHARE_GROUP_VIEWER',
  TIP_SHARE_GROUP_EDIT = 'CBO_TIP_SHARE_GROUP_EDITOR',
  TIP_SHARE_GROUP_CREATE = 'CBO_TIP_SHARE_GROUP_CREATOR',
  TIP_SHARE_GROUP_ADMIN = 'CBO_TIP_SHARE_GROUP_ADMIN',

  // House Accounts
  HOUSE_ACCOUNT_READER = 'CBO_HOUSE_ACCOUNT_READER',
  HOUSE_ACCOUNT_WRITER = 'CBO_HOUSE_ACCOUNT_WRITER',

  // Invoices
  INVOICE_CREATE = 'CBO_INVOICE_CREATOR',
  INVOICE_EDIT = 'CBO_INVOICE_EDITOR',
  INVOICE_ACCEPT = 'CBO_INVOICE_ACCEPT',
  INVOICE_ACCEPT_NEW = 'CBO_INVOICE_ACCEPT_NEW',
  INVOICE_VIEW = 'CBO_INVOICE_READER',
  INVOICE_DELETE = 'CBO_INVOICE_DELETE',
  INVOICE_DELETE_FINALIZED = 'CBO_INVOICE_DELETE_FINALIZED',
  INVOICE_FINALIZE = 'CBO_INVOICE_FINALIZE',
  INVOICE_FINALIZE_NEW = 'CBO_INVOICE_FINALIZE_NEW',
  INVOICE_UNFINALIZE = 'CBO_INVOICE_UNFINALIZE',

  // MISC
  LINK_ADMIN = 'CBO_LINK_ADMIN',
  LINK_VIEW = 'CBO_LINK_VIEWER',
  EVENT_TYPE_VIEWER = 'CBO_EVENT_TYPE_VIEWER',
  GUEST_CHECK_VIEWER = 'CBO_GUEST_CHECK_VIEWER',
  SELF_SERVICE = 'CBO_SELF_SERVICE',

  // Notification
  NOTIFICATION_EDITOR = 'CBO_NOTIFICATION_EDITOR',
  NOTIFICATION_VIEWER = 'CBO_NOTIFICATION_VIEWER',
  NOTIFICATION_GROUP_VIEWER = 'CBO_NOTIFICATION_GROUP_VIEWER',
  NOTIFICATION_GROUP_EDIT = 'CBO_NOTIFICATION_GROUP_EDITOR',

  // Site
  SITE_EDIT = 'CBO_SITE_EDITOR',
  SITE_VIEW = 'CBO_SITE_VIEWER',
  SITE_GROUP_EDITOR = 'CBO_SITE_GROUP_EDITOR',
  SITE_GROUP_VIEWER = 'CBO_SITE_GROUP_VIEWER',
  GROUP_TYPE_EDITOR = 'CBO_GROUP_TYPE_EDITOR',
  GROUP_TYPE_VIEWER = 'CBO_GROUP_TYPE_VIEWER',

  SITE_DAY_PART_EDIT = 'CBO_SITE_DAY_PART_EDITOR',
  SITE_DAY_PART_VIEW = 'CBO_SITE_DAY_PART_VIEWER',
  SITE_DAY_PART_ADMIN = 'CBO_SITE_DAY_PART_ADMIN',

  SITE_TAG_EDIT = 'CBO_SITE_TAG_EDITOR',
  SITE_TAG_VIEW = 'CBO_SITE_TAG_VIEWER',

  ORGANIZATION_VIEW = 'CBO_ORGANIZATION_VIEWER',

  // Payroll
  // TODO

  // Raw Items
  RAW_ITEM_VIEW = 'CBO_RAW_ITEM_VIEWER',
  RAW_ITEM_CREATE = 'CBO_RAW_ITEM_CREATOR',
  RAW_ITEM_EDIT = 'CBO_RAW_ITEM_EDITOR',
  RAW_ITEM_DELETE = 'CBO_RAW_ITEM_DELETE',
  RAW_ITEM_EDIT_ACTIVE = 'CBO_RAW_ITEM_EDIT_ACTIVE',

  // Reports
  SALES_SUMMARY_VIEW = 'SALES_SUMMARY_VIEWER',
  PAYMENT_REPORT_VIEW = 'PAYMENT_REPORT_VIEWER',
  DISCOUNT_REPORT_VIEW = 'DISCOUNT_REPORT_VIEWER',
  TAX_REPORT_VIEW = 'TAX_REPORT_VIEWER',
  REVENUE_CENTER_REPORT_VIEW = 'REVENUE_CENTER_REPORT_VIEWER',
  PROFIT_LOSS_REPORT_VIEW = 'PROFIT_LOSS_REPORT_VIEWER',
  VOID_REPORT_VIEW = 'VOID_REPORT_VIEWER',
  REFUND_REPORT_VIEW = 'REFUND_REPORT_VIEWER',
  TRANSACTION_DETAIL_VIEW = 'TRANSACTION_DETAIL_VIEWER',
  GUEST_CHECK_VIEW = 'CBO_GUEST_CHECK_VIEWER',
  PRODUCT_MIX_REPORT_VIEW = 'PRODUCT_MIX_REPORT_VIEWER',
  POS_EVENT_LOG_VIEW = 'CBO_POS_EVENT_LOG_VIEWER',
  SALE_TRANSACTION_VIEW = 'CBO_SALE_TRANSACTION_VIEWER',
  AUDIT_LOG_VIEW = 'CBO_AUDIT_LOG_VIEWER',
  EMPLOYEE_JOBCODE_HISTORY_VIEW = 'EMPLOYEE_JOBCODE_HISTORY_VIEWER',
  EMPLOYEE_PERFORMANCE_VIEW = 'CBO_REPORT_EMPLOYEE_PERFORMANCE_VIEWER',
  INTERVAL_SALES_LABOR_VIEW = 'CBO_REPORT_INTERVAL_SALES_LABOR_VIEWER',
  PAYROLL_VIEW = 'CBO_REPORT_PAYROLL_VIEWER',
  EMPLOYEE_BREAK_VIEW = 'CBO_REPORT_EMPLOYEE_BREAK_VIEWER',
  PAYROLL_EXPORT_VIEW = 'CBO_REPORT_PAYROLL_EXPORT_VIEWER',
  EMPLOYEE_TIPS_VIEW = 'CBO_REPORT_EMPLOYEE_TIPS_VIEWER',
  APPROACHING_OVERTIME_REPORT_VIEW = 'CBO_REPORT_APPROACHING_OVERTIME_VIEWER',
  ACA_THRESHOLD_VIEW = 'CBO_REPORT_ACA_THRESHOLD_VIEWER',
  SCHEDULING_MANAGER_REPORT_VIEW = 'CBO_REPORT_SCHEDULING_MANAGER_VIEWER',

  // Schedule
  SCHEDULE_VIEW = 'CBO_SCHEDULE_VIEWER',
  SCHEDULE_PERSONAL_VIEW = 'CBO_SCHEDULE_PERSONAL_VIEWER',
  SCHEDULE_PUBLISH = 'CBO_SCHEDULE_PUBLISHER',
  SCHEDULE_DELETE = 'CBO_SCHEDULE_REMOVER',
  SCHEDULE_WORK_WEEK = 'CBO_SCHEDULE_WORK_WEEK_VIEWER',
  SCHEDULE_WORK_WEEK_EDITOR = 'CBO_SCHEDULE_WORK_WEEK_EDITOR',

  // Shifts
  SHIFT_VIEW = 'CBO_SHIFT_VIEWER',
  SHIFT_CREATE = 'CBO_SHIFT_CREATOR',
  SHIFT_EDIT = 'CBO_SHIFT_EDITOR',
  SHIFT_DELETE = 'CBO_SHIFT_REMOVER',

  // Planned Shifts
  PLANNED_SHIFT_VIEW = 'CBO_PLANNED_SHIFT_VIEWER',
  PLANNED_SHIFT_CREATE = 'CBO_PLANNED_SHIFT_CREATOR',
  PLANNED_SHIFT_EDIT = 'CBO_PLANNED_SHIFT_EDITOR',
  PLANNED_SHIFT_ADMIN = 'CBO_PLANNED_SHIFT_ADMIN',

  ACTUAL_SHIFT_VIEW = 'CBO_ACTUAL_SHIFT_VIEWER',
  ACTUAL_SHIFT_EDIT = 'CBO_ACTUAL_SHIFT_EDITOR',
  ACTUAL_SHIFT_CREATE = 'CBO_ACTUAL_SHIFT_CREATOR',
  ACTUAL_SHIFT_ADMIN = 'CBO_ACTUAL_SHIFT_ADMIN',

  PUNCH_EDIT_SHIFT_VIEW = 'CBO_PUNCH_EDIT_SHIFT_VIEWER',
  PUNCH_EDIT_SHIFT_EDIT = 'CBO_PUNCH_EDIT_SHIFT_EDITOR',
  PUNCH_EDIT_SHIFT_CREATE = 'CBO_PUNCH_EDIT_SHIFT_CREATOR',
  PUNCH_EDIT_SHIFT_ADMIN = 'CBO_PUNCH_EDIT_SHIFT_ADMIN',

  // Vendors
  VENDOR_CREATE = 'CBO_VENDOR_CREATOR',
  DRAFT_VENDOR_CREATE = 'CBO_DRAFT_VENDOR_CREATOR',
  VENDOR_EDIT = 'CBO_VENDOR_EDITOR',
  VENDOR_EDIT_ACTIVE = 'CBO_VENDOR_EDIT_ACTIVE',
  VENDOR_VIEW = 'CBO_VENDOR_VIEWER',
  VENDOR_ITEM_ACCEPT = 'CBO_VENDOR_ITEM_ACCEPT',
  VENDOR_ITEM_CREATE = 'CBO_VENDOR_ITEM_CREATOR',
  DRAFT_VENDOR_ITEM_CREATE = 'CBO_DRAFT_VENDOR_ITEM_CREATOR',
  VENDOR_ITEM_EDIT = 'CBO_VENDOR_ITEM_EDITOR',
  VENDOR_ITEMS_VIEW = 'CBO_VENDOR_ITEMS_VIEWER',

  // Units of Measure
  UNITS_OF_MEASURE_CREATE = 'CBO_CUSTOM_UOM_CREATOR',
  UNITS_OF_MEASURE_DELETE = 'CBO_CUSTOM_UOM_DELETE',
  UNITS_OF_MEASURE_VIEW = 'CBO_UOM_VIEWER',
  UNITS_OF_MEASURE_EDIT = 'CBO_CUSTOM_UOM_EDITOR',

  // Mobile Inventory
  MOBILE_INVENTORY_COUNT_EDIT = 'CBO_INVENTORY_COUNT_EDITOR',
  MOBILE_INVENTORY_LISTS_EDIT = 'CBO_INVENTORY_LISTS_EDITOR',
  MOBILE_INVENTORY_LOCATIONS_EDIT = 'CBO_INVENTORY_LOCATIONS_EDITOR',
  MOBILE_INVENTORY_VIEW = 'CBO_INVENTORY_VIEWER',

  // Menu
  SALES_ITEM_VIEW = 'CBO_SALES_ITEM_VIEWER',
  SALES_ITEM_CREATE = 'CBO_SALES_ITEM_CREATOR',

  //ADMIN
  FIREBASE_MESSAGING_TOKEN_CREATOR = 'CBO_FIREBASE_MESSAGING_TOKEN_CREATOR',
  CORE_DEV_MESSAGING_ADMIN = 'CBO_CORE_DEV_MESSAGING_ADMIN',
  CORE_DEV_MESSAGING_PUBLISHER = 'CBO_CORE_DEV_MESSAGING_PUBLISHER',
  CORE_DEV_MESSAGING_SUBSCRIBER = 'CBO_CORE_DEV_MESSAGING_SUBSCRIBER',
  ADMIN_DASHBOARD_VIEWER = 'ADMIN_DASHBOARD_VIEWER',
  USERS_ADMIN = 'CBO_USERS_ADMIN',
  ONBOARDING_ADMIN = 'CBO_ONBOARDING_ADMIN',
  EMAIL_MESSAGE_SENDER = 'CBO_EMAIL_MESSAGE_SENDER',
  SMS_MESSAGE_SENDER = 'CBO_MESSAGE_SENDER',
  DEVEX_MESSAGING_PUBLISHER = 'DEVEX_MESSAGING_PUBLISHER',

  // GL Accounts
  GL_ACCOUNTS_READ = 'CBO_GL_ACCOUNTS_READER',
  GL_ACCOUNTS_WRITE = 'CBO_GL_ACCOUNTS_WRITER',
  GL_ACCOUNTS_ADMIN = 'CBO_GL_ACCOUNTS_ADMIN',

  // Sales Report Config
  SALES_CONFIG_READER = 'CBO_SALES_CONFIG_READER',
  SALES_CONFIG_WRITER = 'CBO_SALES_CONFIG_WRITER',
  SALES_CONFIG_ADMIN = 'CBO_SALES_CONFIG_ADMIN',

  //NCRID
  IDENTITY_IT_ADMIN = 'IDENTITY_IT_ADMIN',
  IDENTITY_ABOVE_STORE_MANAGER = 'IDENTITY_ABOVE_STORE_MANAGER',
  IDENTITY_STORE_MANAGER = 'IDENTITY_STORE_MANAGER',
  IDENTITY_ASSISTANT_MANAGER = 'IDENTITY_ASSISTANT_MANAGER',
  NEP_ENTERPRISE_SUPER_ADMINISTRATOR = 'NEP_ENTERPRISE_SUPER_ADMINISTRATOR',
  NEP_IDENTITY_VIEWER = 'NEP_IDENTITY_VIEWER',
  NEP_IDENTITY_UPDATE = 'NEP_IDENTITY_UPDATE',

  //Cash Office
  FINANCIAL_SHIFT_MANAGER_VIEWER = 'CBO_FINANCIAL_SHIFT_MANAGER_VIEWER',
  FINANCIAL_SHIFT_MANAGER_WRITER = 'CBO_FINANCIAL_SHIFT_MANAGER_WRITER',

  // Recipe
  RECIPE_VIEWER = 'CBO_RECIPE_VIEWER',
  RECIPE_CREATOR = 'CBO_RECIPE_CREATOR',
  RECIPE_EDITOR = 'CBO_RECIPE_EDITOR',

  // Recipe Item or Ingredients
  RECIPE_ITEM_CREATOR = 'CBO_RECIPE_ITEM_CREATOR',
  RECIPE_ITEM_EDITOR = 'CBO_RECIPE_ITEM_EDITOR',
  RECIPE_ITEM_VIEWER = 'CBO_RECIPE_ITEM_VIEWER',
}

/**
 * @deprecated Use CboRole
 */
export const CboPermission = CboRole;

const cboPermissionSet: Set<string> = new Set(Object.values(CboRole));

export const isCboRole = (p: string): p is CboRole => cboPermissionSet.has(p);

/**
 * @deprecated use isCboRole
 */
export const isCboPermission = isCboRole;

export interface OrgAuth {
  sites: Record<string, SiteInfo>;
  enterpriseUnitIds: string[]; // Used for firebase rules
  permissions: CboRole[];
  roles: string[];
  // TODO: Add display name to both firestore and the token
  /** @deprecated We actually receive the long name now and this field will hold the long name. Please convert to using bslLongName asap */
  bslShortName: string;
  bslLongName: string;
  id: string;
  bslId: string;
}

export interface OrgAuthNcrId extends Omit<OrgAuth, 'roles' | 'id'> {
  personas: PersonaRole[];
  displayName: string;
}

type RemovedOrgAuthKeys = 'personas' | 'sites' | 'enterpriseUnitIds' | 'permissions' | 'bslShortName';

export type MinimalOrgAuth = Omit<OrgAuthNcrId, RemovedOrgAuthKeys>;
export interface UserInfo {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  name: string;
}
export interface CboTokenClaims {
  org: OrgAuth;
  user: UserInfo;
}

export interface CboTokenClaimsNcrId {
  org: OrgAuthNcrId;
  user: UserInfo;
}

export interface MinimalCboTokenClaims {
  org: MinimalOrgAuth;
  user: UserInfo;
}

export interface SiteInfo {
  enterpriseUnitId: string;
  name?: string;
  referenceId?: string;
  timeZone?: string;
}

export enum PersonaRole {
  ADMIN = 'ASM_IT_ADMIN',
  ASSISTANT_MANAGER = 'ASM_ASSISTANT_MANAGER',
  EMPLOYEE = 'ASM_EMPLOYEE',
  SUPPORT = 'ASM_NCR_SUPPORT',
  MANAGER = 'ASM_STORE_MANAGER',
  ACCOUNTANT = 'ASM_SUPPORT_FUNCTIONS',
}

export const personaRoleSet: Set<string> = new Set(Object.values(PersonaRole));

export const isPersonaRole = (role: string): role is PersonaRole => personaRoleSet.has(role);
